import imageCompression from 'browser-image-compression'

export async function compressImage(file: File, {
    maxSizeMB = 0.08,
    maxWidthOrHeight = 1024,
    useWebWorker = false,

}= {}){
    var options = {
        maxSizeMB: maxSizeMB,
        maxWidthOrHeight: maxWidthOrHeight,
        useWebWorker
      }

    const output = await imageCompression(file, options)

    return output

    
}